import React from 'react';
import { AddressField as AddressFieldUI } from 'decentraland-ui/dist/components/AddressField';
import { resolveName } from './utils';
export function AddressField(props) {
    return React.createElement(AddressFieldUI, { ...props, resolveName: resolveName });
}
//# sourceMappingURL=AddressField.js.map